<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': gender_touched}" type="button" data-toggle="dropdown">
            Moradia para
        </button>

        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">Moradia para</p>

            <div class="form-group">
                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="gender" id="gender_both" v-model="model" value="MF"/>
                    <label for="gender_both">Mistas</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="gender" id="gender_f" v-model="model" value="F"/>
                    <label for="gender_f">Apenas para mulheres</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="gender" id="gender_m" v-model="model" value="M"/>
                    <label for="gender_m">Apenas para homens</label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.gender || [],
        }
    },
    watch: {
        selected_gender: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        selected_gender() {
            return this.$store.getters.getFilter.gender || [];
        },
        gender_touched() {
            return this.selected_gender.length > 0;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', { gender: this.model });
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>